import React, { useState, createContext, useMemo, useCallback } from 'react';

import { ModalKey } from 'components/Modal/Root';

export interface ModalProps {
  mode: 'edit' | 'add' | 'lookup' | 'select';
  /* eslint-disable-next-line */
  data?: Record<string, any>;
  /* eslint-disable-next-line */
  onConfirm?: (...args: any[]) => void;
}

export interface Modal {
  key: ModalKey;
  props?: ModalProps;
}

export interface IModalContext {
  modals: Modal[];
  openModal: (key: ModalKey, data?: ModalProps) => void;
  closeModal: (key: ModalKey) => void;
}

const ModalContext = createContext({} as IModalContext);

export const ModalProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [list, setList] = useState<Modal[]>([]);

  const openModal = useCallback((key: ModalKey, props?: ModalProps): void => {
    setList((oldList) => [...oldList, { key, props }]);
  }, []);

  const closeModal = useCallback((key: string): void => {
    setList((oldList) => oldList.filter((modal) => modal.key !== key));
  }, []);

  const value = useMemo(() => {
    return {
      modals: list,
      openModal,
      closeModal,
    };
  }, [list, openModal, closeModal]);

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};

export type { ModalKey } from 'components/Modal/Root';
export default ModalContext;
